import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors.jsx";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import Button from "./components/button.jsx";
import TextInput from "./components/textBox.jsx";
import Link from "./components/link.jsx";
import DropDown from "./components/dropdown.jsx";
import Alert from "@mui/material/Alert";
import { capitalizeEveryWord, parseDate } from "./util.jsx";

class Profile extends React.Component {
  constructor(props) {
    // Initialize mutable state
    super(props);
    this.state = {
      salaries: [],
      account: true,
      entries: false,
      changePass: false,
      uname: "lol",
      email: "",
      newEmail: "",
      phone: "",
      newPhone: "",
      edu: "",
      newEdu: "",
      password: "",
      newRepassword: "",
      newPassword: "",
      passfail: false,
      newPassfail: false,
      newrePassfail: false,
      passSaveDis: true,
      passSucess: false,
      updateSuccess: false,
      changeEmail: false,
      changePhone: false,
      changeEdu: false,
      emailFail: false,
      phoneFail: false,
      phoneUnique: true,
      passSavecolor: Colors.lightSpaceGray,
      updateSaveDis: true,
      updateSavecolor: Colors.lightSpaceGray,
      uniquePass: true,
      eduOptionsList: [
        "Secondary",
        "Diploma",
        "Bachelor",
        "Master",
        "PHD",
        "Associate",
      ],
    };
  }
  componentDidMount() {
    // Check if user is logged in
    fetch("/api/v1/user", { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        this.setState(
          {
            uname: data.username,
            email: data.email,
            phone: data.phone,
            edu: data.education_level,
          },
          this.getSalaries,
        );
      })
      .catch((error) => console.log(error));
  }
  getSalaries() {
    let url =
      "/api/internal/v1/salary?" +
      new URLSearchParams({
        user: this.state.email,
        limit: 100,
      });

    fetch(url, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        this.setState({ salaries: JSON.parse(data.salaries) }, () => {
          const sortedSalaries = this.state.salaries.sort((a, b) => {
            return b.created_at.$date - a.created_at.$date;
          });
          this.setState({ salaries: sortedSalaries });
        });
      })
      .catch((error) => console.log(error));
  }

  //education and phone and email change form function
  checkUpdates() {
    const {
      newEdu,
      newEmail,
      password,
      newPhone,
      phoneFail,
      emailFail,
      changeEdu,
      changeEmail,
      changePhone,
    } = this.state;
    if (
      (!changeEmail || newEmail) &&
      (!changeEdu || newEdu) &&
      password &&
      (!changePhone || newPhone.length == 13) &&
      !(emailFail || phoneFail)
    ) {
      this.setState({
        updateSavecolor: Colors.strangegreen,
        updateSaveDis: false,
      });
      return false;
    } else {
      this.setState({
        updateSavecolor: Colors.lightSpaceGray,
        updateSaveDis: true,
      });
      return true;
    }
  }

  handleEmailChange = (value) => {
    this.setState({ newEmail: value }, () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.state.newEmail)) {
        this.setState({ emailFail: true }, this.checkUpdates);
      } else {
        this.setState({ emailFail: false }, this.checkUpdates);
      }
    });
  };
  handlePhoneChange = (value) => {
    // Do something with the input value
    this.setState({ newPhone: value, phoneUnique: true }, () => {
      const phoneRegex = /^\+9665[0-9]{8}$/;
      if (!phoneRegex.test(this.state.newPhone)) {
        this.setState({ phoneFail: true }, this.checkUpdates);
      } else {
        this.setState({ phoneFail: false }, this.checkUpdates);
      }
    });
  };
  handleEduChange = (value) => {
    // Do something with the input value
    this.setState({ newEdu: value }, this.checkUpdates);
  };
  handlePasswordChange = (value) => {
    this.setState({ password: value }, () => {
      const { password, newPassword } = this.state;
      if (password == newPassword && newPassword) {
        this.setState({ uniquePass: false });
      } else {
        this.setState({ uniquePass: true });
      }
      this.checkUpdates();
      this.checkEmptyPass();
    });
  };
  //check if fields are empty to lightup the submit button
  checkEmptyPass() {
    const {
      newPassfail,
      newrePassfail,
      newPassword,
      newRepassword,
      password,
      uniquePass,
    } = this.state;
    if (
      newPassword &&
      newRepassword &&
      password &&
      !(newPassfail || newrePassfail) &&
      uniquePass
    ) {
      this.setState({ passSavecolor: Colors.strangegreen, passSaveDis: false });
      return false;
    } else {
      this.setState({
        passSavecolor: Colors.lightSpaceGray,
        passSaveDis: true,
      });
      return true;
    }
  }
  // password form functions
  // handle the password changing in the text field and checks password is the right strength by using a regex
  handleNewPasswordChange = (value) => {
    // Do something with the input value

    this.setState({ newPassword: value }, () => {
      this.matchPass();
      const { password, newPassword } = this.state;
      if (password == newPassword && newPassword) {
        this.setState({ uniquePass: false }, this.passCheck);
      } else {
        this.setState({ uniquePass: true }, this.passCheck);
      }
    });
  };
  passCheck() {
    const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
    if (
      !passwordRegex.test(this.state.newPassword) ||
      this.state.newPassword.length < 8
    ) {
      this.setState({ newPassfail: true }, this.checkEmptyPass);
    } else {
      this.setState({ newPassfail: false }, this.checkEmptyPass);
    }
  }
  // handle the password re-entry changing in the text field and if it is equal to the password
  handleNewRePasswordChange = (value) => {
    // Do something with the input value
    this.setState({ newRepassword: value }, this.matchPass);
  };
  matchPass() {
    if (
      this.state.newPassword !== this.state.newRepassword &&
      this.state.newRepassword
    ) {
      this.setState({ newrePassfail: true }, this.checkEmptyPass);
    } else {
      this.setState({ newrePassfail: false }, this.checkEmptyPass);
    }
  }
  changePassword() {
    const formData = new FormData();
    formData.append("password", this.state.password);
    formData.append("new_password1", this.state.newPassword);
    formData.append("new_password2", this.state.newRepassword);
    formData.append("operation", "update_password");
    // Submit the form
    fetch(`/accounts/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    }).then((response) => {
      //check response
      if (response.ok) {
        this.setState({ passSucess: true, changePass: false }); // open the confirmation box
      } else {
        // Handle password wrong failure, show message

        if (response.status == 403) {
          this.setState({ passfail: true });
        }
      }
    });
  }

  saveChanges() {
    const formData = new FormData();
    formData.append("password", this.state.password);
    formData.append("phone", this.state.newPhone);
    formData.append("education_level", this.state.newEdu);
    formData.append("operation", "edit_account");
    // Submit the form
    fetch(`/accounts/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    }).then((response) => {
      //check response
      if (response.ok) {
        this.changePassform(); // reset everything
        this.setState({ updateSuccess: true }); // send a confirmation message

        //display new info
        fetch("/api/v1/user", { credentials: "same-origin" })
          .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
          })
          .then((data) => {
            this.setState({
              phone: data.phone,
              edu: data.education_level,
            });
          })
          .catch((error) => console.log(error));
      } else {
        // Handle update failure, show error message

        //if password failed show it
        if (response.status == 403) {
          this.setState({ passfail: true });
        }
        if (response.status == 409) {
          this.setState({ phoneUnique: false });
        }
      }
    });
  }

  changePassform(value) {
    this.state;
    this.setState({
      changePass: value,
      passSucess: false,
      updateSuccess: false,
      password: "",
      newPassword: "",
      newRepassword: "",
      newEmail: "",
      newPhone: "",
      newEdu: "",
      newPassfail: false,
      newrePassfail: false,
      changeEmail: false,
      changePhone: false,
      changeEdu: false,
    });
  }

  render() {
    // This line automatically assigns this.state.imgUrl to the const variable imgUrl
    // and this.state.owner to the const variable owner
    const {
      salaries,
      entries,
      account,
      changePass,
      password,
      newPassword,
      newRepassword,
      passfail,
      newPassfail,
      newrePassfail,
      passSaveDis,
      passSavecolor,
      passSucess,
      changeEmail,
      changePhone,
      changeEdu,
      newEmail,
      newPhone,
      newEdu,
      emailFail,
      phoneFail,
      eduOptionsList,
      updateSavecolor,
      updateSaveDis,
      uniquePass,
      updateSuccess,
      phoneUnique,
    } = this.state;

    // Render
    return (
      <MainCol>
        <NavBar />
        <MainRow>
          <Tabs>
            <TabSpine></TabSpine>
            <Tab
              style={{ paddingRight: account ? "50%" : "" }}
              onClick={() => {
                this.setState({ account: true, entries: false });
                this.changePassform(false);
              }}
            >
              Account Info{" "}
            </Tab>

            <Tab
              style={{ paddingRight: entries ? "50%" : "" }}
              onClick={() => {
                this.setState({ account: false, entries: true });
                this.changePassform(false);
              }}
            >
              Contributions{" "}
            </Tab>
          </Tabs>

          <Pages>
            {account && (
              <Page>
                <Label>Email</Label>
                <Field>
                  {changeEmail ? (
                    <TextInput
                      readonly={false}
                      onKeyDown={this.submitOnEnter}
                      value={newEmail}
                      placeholder={"New email"}
                      func={this.handleEmailChange}
                      // isfailed={Emailfail || notUnique} un comment when response is implemented
                    />
                  ) : (
                    <p>{this.state.email}</p>
                  )}
                  {/* <ImageContainer>
                <img style={{width:"16px"}} onClick={()=>{this.setState({changeEmail:!changeEmail, newEmail:""},this.checkUpdates);if(!(changeEmail || changePhone || changeEdu)){
                  this.setState({password:""})
                }}}
                src={!changeEmail?
                 "..\\..\\static\\images\\pencil.svg":
                 "..\\..\\static\\images\\x.svg"} />
                </ImageContainer> */}
                </Field>
                <Label>Phone</Label>
                <Field>
                  {changePhone ? (
                    <FlexCol>
                      <TextInput
                        style={{ width: "" }}
                        value={newPhone}
                        placeholder={"+9665xxxxxxxx"}
                        func={this.handlePhoneChange}
                        isfailed={phoneFail || !phoneUnique}
                      />
                      {phoneFail && (
                        <Alert severity="error">Invalid Phone Number.</Alert>
                      )}
                      {!phoneUnique && (
                        <Alert severity="error">
                          Phone Number Already In Use.
                        </Alert>
                      )}
                    </FlexCol>
                  ) : (
                    <p>{this.state.phone}</p>
                  )}
                  <ImageContainer>
                    <img
                      style={{ width: "16px" }}
                      onClick={() => {
                        this.setState(
                          {
                            changePhone: !changePhone,
                            changePass: false,
                            newPhone: "+9665",
                            phoneFail: false,
                          },
                          this.checkUpdates,
                        );
                        if (!(changeEmail || changePhone || changeEdu)) {
                          this.setState({ password: "" });
                        }
                      }}
                      src={
                        !changePhone
                          ? "..\\..\\static\\images\\pencil.svg"
                          : "..\\..\\static\\images\\x.svg"
                      }
                      alt={!changePhone ? "Edit phone number" : "Cancel edit"}
                    />
                  </ImageContainer>
                </Field>
                <Label>Education Level</Label>
                <Field>
                  {changeEdu ? (
                    <DropDown
                      value={newEdu}
                      placeholder={"Education Level"}
                      func={this.handleEduChange}
                      options={eduOptionsList}
                    />
                  ) : (
                    <p>{this.state.edu}</p>
                  )}

                  <ImageContainer>
                    <img
                      style={{ width: "16px" }}
                      onClick={() => {
                        this.setState(
                          {
                            changeEdu: !changeEdu,
                            newEdu: "",
                            changePass: false,
                          },
                          this.checkUpdates,
                        );
                        if (!(changeEmail || changePhone || changeEdu)) {
                          this.setState({ password: "" });
                        }
                      }}
                      src={
                        !changeEdu
                          ? "..\\..\\static\\images\\pencil.svg"
                          : "..\\..\\static\\images\\x.svg"
                      }
                      alt={!changeEdu ? "Edit education level" : "Cancel edit"}
                    />
                  </ImageContainer>
                </Field>
                <Label>Password</Label>
                {(changeEmail || changePhone || changeEdu) && (
                  <>
                    <TextInput
                      type="password"
                      value={password}
                      placeholder={"Password"}
                      func={this.handlePasswordChange}
                      isfailed={passfail}
                    />
                    {passfail && (
                      <Alert severity="error">Incorrect password</Alert>
                    )}
                  </>
                )}
                <Button
                  disable={
                    changeEmail || changePhone || changeEdu
                      ? updateSaveDis
                      : false
                  }
                  style={{ marginTop: "0" }}
                  color={
                    changeEmail || changePhone || changeEdu
                      ? updateSavecolor
                      : Colors.strangegreen
                  }
                  title={
                    changeEmail || changePhone || changeEdu
                      ? "Save Changes"
                      : "Change Password"
                  }
                  func={() => {
                    if (changeEmail || changePhone || changeEdu) {
                      this.saveChanges();
                    } else {
                      this.changePassform(!changePass);
                      this.checkEmptyPass();
                    }
                  }}
                />
                {updateSuccess && (
                  <Alert severity="success">Changes saved succesfuly</Alert>
                )}
                {passSucess && (
                  <Alert severity="success">Password changed succesfuly</Alert>
                )}
                {changePass && (
                  <PassForm>
                    <TextInput
                      type="password"
                      value={password}
                      placeholder={"Password"}
                      func={this.handlePasswordChange}
                      isfailed={passfail}
                    />
                    {passfail && (
                      <Alert severity="error">Incorrect password</Alert>
                    )}
                    <TextInput
                      type="password"
                      value={newPassword}
                      placeholder={"New Password"}
                      func={this.handleNewPasswordChange}
                      isfailed={newPassfail || !uniquePass}
                    />
                    {newPassfail && (
                      <Alert severity="error">
                        Password must be 8+ characters and include letters,
                        numbers.
                      </Alert>
                    )}
                    {!uniquePass && (
                      <Alert severity="error">
                        Old password cannot be the same as new password.
                      </Alert>
                    )}
                    <TextInput
                      type="password"
                      value={newRepassword}
                      placeholder={"Re-Enter New Password"}
                      func={this.handleNewRePasswordChange}
                      isfailed={newrePassfail}
                    />
                    {newrePassfail && (
                      <Alert severity="error">The re-entry doesnt match.</Alert>
                    )}
                    <Button
                      disable={passSaveDis}
                      color={passSavecolor}
                      title={"Submit Change"}
                      func={() => this.changePassword()}
                    />
                  </PassForm>
                )}
              </Page>
            )}
            {entries && (
              <Page>
                {salaries.length > 0 ? (<Salaries>
                   {salaries.map((salary, index) => (
                    <Salary key={index}>
                      <FlexRowS>
                        <FlexColS>
                          <Label>Role:</Label>
                          <SP>{capitalizeEveryWord(salary.role)}</SP>
                        </FlexColS>{" "}
                        <FlexColS>
                          <Label>Salary:</Label>{" "}
                          <SP>
                            {salary.salary_per_month} {salary.currency}
                          </SP>
                        </FlexColS>{" "}
                      </FlexRowS>
                      <FlexRowS>
                        <FlexColS>
                          <Label>Company:</Label>
                          <SP>{capitalizeEveryWord(salary.company_name)}</SP>
                        </FlexColS>{" "}
                        <FlexColS>
                          <Label>Experience:</Label>{" "}
                          <SP>{salary.experience_in_yrs} Years</SP>
                        </FlexColS>{" "}
                      </FlexRowS>
                      <FlexRowS>
                        <FlexColS>
                          <Label>Location:</Label>
                          <SP>{capitalizeEveryWord(salary.location_city)}</SP>
                        </FlexColS>{" "}
                        <FlexColS>
                          <Label>Date Added:</Label>{" "}
                          <SP>{parseDate(salary.created_at)}</SP>
                        </FlexColS>{" "}
                      </FlexRowS>
                    </Salary>
                  ))}
                </Salaries>)
                :
                <Salaries>
                  <h1 style={{textAlign: 'center'}}>You have not added any contribution</h1> 
                  <AddButton onClick={()=>{window.location.href='/addsalary/'}}>Add Salary</AddButton> 
                </Salaries>}
              </Page>
            )}
          </Pages>
        </MainRow>
        <Footer />
      </MainCol>
    );
  }
}
export default Profile;
const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
`;
// Create a flex column display div
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MainRow = styled(FlexRow)`
  width: 50%;
  height: 100%;
  margin: 10% 0 10% 0;
`;
const MainCol = styled(FlexCol)`
  justify-content: space-between;
  height: 100vh;
  margin: 50px;
`;

const Tabs = styled(FlexCol)`
  height: 100%;
  position: relative;
`;
const Tab = styled.div`
  background-color: ${Colors.white};
  border: 1px solid ${Colors.lightGray};
  border-radius: 12px;
  width: 100%;
  padding: 8px;
  text-align: center;
  margin: 8px;
  cursor: pointer;
  transition-duration: 0.2s;
  &:hover {
    text-decoration: underline;
  }
`;
const TabSpine = styled(Tab)`
  margin: 0;
  position: absolute;
  width: 70%;
  top: 10px;
  height: 60px;
  z-index: -5;
`;
const Pages = styled(FlexCol)`
  background-color: ${Colors.white};
  width: 100%;
  min-height: 100%;
  justify-content: space-between;
  margin: 16px;
  align-items: center;
  border-radius: 8px;
  font-size: 12px;
  border: 1px solid ${Colors.lightGray};
  z-index: 3;
`;
const Page = styled(FlexCol)`
  margin: 8px;
  width: 90%;
  align-items: center;
`;

const Label = styled.label`
  font-size: 16px;
  width: 100%;
  display: block;
  font-weight: bold;
  margin: 4px;
`;

const PassForm = styled(FlexCol)`
  width: 90%;
`;

const Field = styled(FlexRow)`
  width: 100%;
  margin: 0;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px solid ${Colors.lightGray};
`;

const ImageContainer = styled.div`
  width: 10%;
  cursor: pointer;
  align-self: right;
`;

const Salaries = styled.ul`
  list-style: none;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
`;
const Salary = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 16px;
  margin-bottom: 32px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid ${Colors.lightGray};
`;

const FlexRowS = styled(FlexRow)`
  width: 100%;
  text-align: left;
  padding: 0;
`;
const FlexColS = styled(FlexCol)`
  width: 100%;
`;
const SP = styled.div`
  padding: 8px;
`;

const AddButton = styled.button`
  font-size: 14px;
  background-color: ${Colors.strangegreen};
  color: ${Colors.white};
  padding: 10px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 90%;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${Colors.darkstrangegreen};
  }

  &:active {
    background-color: ${Colors.brightstrangegreen};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.5);
  }
`;